import { tabAccessControl } from "../../../_helpers/access-control";

let BillOfMaterialsAllTabs = [
  {
    text: "BOM List",
    path: `/bill-of-materials`,
    applicationFeatureCode: "BillOfMaterial",
  },
  {
    text: "Bulk Update",
    path: `/bill-of-materials-bulk-update`,
    applicationFeatureCode: "BulkBOMUpdate",
  },
];

function GetIndexByTabName(tabName) {
  return tabAccessControl(BillOfMaterialsAllTabs).findIndex((x) => x.text == tabName);
}

export { BillOfMaterialsAllTabs, GetIndexByTabName };
